import { IAppSuiteEnabledApps } from '@microsoft/portal-app/lib/AppSuite';
import { AppKeys } from '@microsoft/portal-app/lib/environment';
import { IAppInfo } from '../Application/Main/interfaces';
import { MY_GROUPS_PATH } from '../shared/constants';
import { getTelemetry } from '../Telemetry/Telemetry';
import { IAppItem } from '@iamexperiences/suite-header';

export const getMenuItems = (
  appsMap: ReadonlyMap<AppKeys, IAppInfo>,
  showMyAccess: boolean,
  upn?: string,
  tenantId?: string,
): IAppItem[] => {
  const appItems: IAppItem[] = [];
  const selectedApp = getSelectedApp();
  for (const [key, value] of appsMap) {
    // per request to recognize new SKU service plan, either tenant has P2 or any SKU with P1 are able to see myaccess link
    if (key === AppKeys.access && !showMyAccess) {
      continue;
    }

    const app = value;
    if (key === selectedApp) {
      appItems.push({
        key,
        text: app.appName,
        selected: true,
        href: app.defaultUrl,
        target: '_self',
      });
    } else {
      const baseUrl = new URL(app.defaultUrl);
      baseUrl.searchParams.set('tenantId', tenantId || '');
      baseUrl.searchParams.set('upn', upn || '');
      appItems.push({
        key,
        text: app.appName,
        href: baseUrl.toString(),
        target: '_blank',
        onClick: onSwitchApp(app.appKey),
      });
    }
  }

  return appItems;
};

export const onSwitchApp = (targetApp: string) => () => {
  const telemetry = getTelemetry();
  telemetry.reportCustomEvent('suite-header/app-switcher/switch-app', {
    currentApp: 'My Account',
    targetApp,
  });
};

export const isAppEnabled = (key: string, enabledApps?: IAppSuiteEnabledApps): boolean => {
  if (!enabledApps) {
    return false;
  }
  return enabledApps[key];
};

export const getSelectedApp = () => {
  return window.location.pathname.startsWith(MY_GROUPS_PATH) ? AppKeys.groups : AppKeys.account;
};
